import React from 'react';

import { Button, Box, Typography, Modal } from '@mui/material';

import UnsubscribeIcon from '../../../../common/assets/icons/unsubscribe_icon.svg';
import './SubscriptionPurchasedModal.scss';
import {
  APPLE_UNSUBSCRIBE_URL,
  GOOGLE_UNSUBSCRIBE_URL,
} from '../../../constants/Purchases';
import { StoreType } from '../../../types/RevenueCatTypes';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  onClose: () => void;
  platform: StoreType;
};

const UnsubscribeMobileModal: React.FC<Props> = ({
  open,
  onClose,
  platform,
}) => {
  const redirectToStoreURL = () => {
    if (platform === 'play_store') {
      window.open(GOOGLE_UNSUBSCRIBE_URL, '_blank');
    }

    if (platform === 'app_store') {
      window.open(APPLE_UNSUBSCRIBE_URL, '_blank');
    }
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div>
          <img src={UnsubscribeIcon} alt='Unsubscribe' />

          {platform === 'play_store' && (
            <>
              <Typography fontSize={16} sx={{ mt: 1, mb: 1 }}>
                Your subscription was purchased from Google Play. Cancel online,
                or navigate on your Android device to:
              </Typography>
              <Typography fontSize={16} sx={{ mt: 2, mb: 2 }}>
                Play Store app → Your account → Subscriptions
              </Typography>
              <Typography fontSize={16} sx={{ mt: 1, mb: 1 }}>
                where you can find and cancel the subscription.
              </Typography>
            </>
          )}

          {platform === 'app_store' && (
            <>
              <Typography fontSize={16} sx={{ mt: 1, mb: 1 }}>
                Your subscription was purchased on the Apple App Store. Cancel
                online, or navigate your iOS device to:
              </Typography>
              <Typography fontSize={16} sx={{ mt: 2, mb: 2 }}>
                Settings → Your Apple ID → Subscriptions
              </Typography>
              <Typography fontSize={16} sx={{ mt: 1, mb: 1 }}>
                where you can find and cancel the subscription.
              </Typography>
            </>
          )}

          {platform === 'promotional' && (
            <Typography fontSize={16} sx={{ mt: 1, mb: 1 }}>
              Your subscription is a promotion granted by an administrator and
              it can not be cancelled.
            </Typography>
          )}

          <Button
            onClick={onClose}
            variant='contained'
            color='primary'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '20px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>Okay, thank you</Typography>
          </Button>
          <Button
            onClick={() => redirectToStoreURL()}
            variant='contained'
            color='secondary'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '10px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>Redirect me</Typography>
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default UnsubscribeMobileModal;
